import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as types from './types';
import * as actions from './actions';
import { getUser, login, registrationRequest } from 'api/services/worker';
import { ROUTE } from 'routers/data';

function* watchGetUser() {
  yield takeEvery(types.GET_USER, function* ({ payload }) {
    try {
      const { data } = yield call(getUser, payload);
      yield put(actions.getUserSuccess(data.user));
    } catch (error) {
      yield put(actions.getUserError());
    }
  });
}

function* watchLogin() {
  yield takeEvery(types.LOGIN, function* ({ payload }) {
    try {
      const { data } = yield call(login, payload);
      yield put(actions.loginSuccess(data.user));
    } catch (error) {
      yield put(actions.loginError());
    }
  });
}

function* watchRegistrationRequest() {
  yield takeEvery(types.REGISTRATION_REQUEST, function* ({ payload }) {
    try {
      const { data } = yield call(registrationRequest, payload);
      yield put(actions.registrationRequestSuccess(data.user));
      window.location.href = ROUTE.profileStatus;
    } catch (error) {
      yield put(actions.registrationRequestError());
    }
  });
}

function* ProfileSagas() {
  yield all([
    fork(watchGetUser),
    fork(watchLogin),
    fork(watchRegistrationRequest),
  ]);
}

export default ProfileSagas;
